module.exports = __webpack_public_path__ + "img/impactoE1.8c450952.png";